import { render, staticRenderFns } from "./disclaimer.vue?vue&type=template&id=949a7200&"
import script from "./disclaimer.vue?vue&type=script&lang=js&"
export * from "./disclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('949a7200')) {
      api.createRecord('949a7200', component.options)
    } else {
      api.reload('949a7200', component.options)
    }
    module.hot.accept("./disclaimer.vue?vue&type=template&id=949a7200&", function () {
      api.rerender('949a7200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/disclaimer.vue"
export default component.exports